// @flow

export const statusToTextBadge = {
  draft: {
    textColor: 'white',
    color: 'eclipse',
  },
  inactive: {
    textColor: 'white',
    color: 'sunrise',
  },
  active: {
    textColor: 'white',
    color: 'shamrock',
  },
};
